//@flow
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { enqueueSnackbar } from "notistack";
import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { muiDatePickersLocales } from "../../helpers/mui/muiLocales";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";

import UnauthenticatedRouter from "../../routers/unauthenticatedRouter";
import Content from "./content";

import useUserData from "../../hooks/user/useUserData";
import useUserAction from "../../hooks/user/useUserAction";

import dayjs from "dayjs";
import 'dayjs/locale/el'
import Box from "@mui/material/Box";
import {useMediaQuery, useTheme} from "@mui/material";

const Main = () => {
	const { isLoggedIn, language, loading, loadingITYE, message, roles } = useUserData()
	const { t } = useTranslation(PAGE_LOGIN)
	dayjs.locale(language);
	const { getUserPermissions, setUserMessage, userLogout } = useUserAction()
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


	useEffect(() => {
		if (isLoggedIn) {
			getUserPermissions()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoggedIn])
	
	useEffect(() => {
		if (message) {
			enqueueSnackbar(t(message?.text), {
					variant: message?.variant,
					autoHideDuration: null
				}
			)
			setUserMessage(null)
		}
	}, [message, setUserMessage, t])
	
	if (!isLoggedIn) return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			localeText={muiDatePickersLocales(language)}
		>
			<UnauthenticatedRouter/>
		</LocalizationProvider>
	)
	
	return (
		<Box
			sx={{
				paddingLeft: 'env(safe-area-inset-left)',
				paddingRight: 'env(safe-area-inset-right)',
				paddingTop: 0,
				paddingBottom: 0,
				minHeight: '100dvh',
				backgroundColor: 'background.default',
				boxSizing: 'border-box',
				fontSize: isMobile ? '0.85rem' : '1rem',
				'& button': {
					fontSize: isMobile ? '0.75rem' : '0.85rem',
					padding: isMobile ? '6px 10px' : '8px 11px',
				},
				'& input, & textarea, & select': {
					fontSize: isMobile ? '0.8rem' : '1rem',
				}
			}}
		>
		<SkeletonLoaderWrapper loading={loading && loadingITYE}>
			<LocalizationProvider
				dateAdapter={AdapterDayjs}
				localeText={muiDatePickersLocales(language)}
			>
				<Content/>
			</LocalizationProvider>
		</SkeletonLoaderWrapper>
		</Box>
	)
}

export default Main